import React from 'react';
import styled from 'styled-components';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import ToggleButtonGroup from '@mui/lab/ToggleButtonGroup';
import MUIButton from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { TYPOGRAPHY } from 'shared/design-system/settings/variables/Typography';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { Page as PageUi } from 'shared/components/styled';

export const Page = styled(PageUi)`
  padding: 0px;
  .screen-group {
    background-color: #eaf0f6;
    padding: 24px;
    flex-direction: column;
    align-items: flex-start;
    h2 {
      margin-top: 0px;
      margin-bottom: 12px;
      color: rgb(89, 89, 89);
      font-size: 32px;
      font-weight: 400;
      span {
        color: #99acc2;
        font-size: 24px;
        font-weight: 700;
      }
    }
    .row {
      display: flex;
      flex-direction: row;
      align-items: center;
      .input-title {
        color: rgb(89, 89, 89);
        font-size: 16px;
        font-weight: 700;
        margin-right: 16px;
      }
      .MuiFormControl-root {
        background-color: white;
        height: 48px;
        margin-right: 16px;
        .MuiInputBase-root {
          height: 48px;
        }
      }
      button {
        height: 48px;
        text-transform: none;
        span {
          font-size: 16px;
          font-weight: 700;
        }
      }
    }
  }
`;

export const Root = styled.div``;

export const DetailContainer = styled(Paper).attrs({
  elevation: 2,
})`
  width: 100%;
  border: none !important;
  padding: 0px !important;
  height: calc(100% - 67px);
  overflow-y: auto;
  overflow: -moz-scrollbars-none;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
  .ag-root {
    font-size: 14px;
    font-weight: 400;
    color: #48596b;
    font-family: 'Open Sans', 'Nunito Sans', 'Roboto', 'Arial' !important;
    .ag-header-row {
      font-size: 14px;
      font-weight: 700;
      color: #48596b;
    }
  }
`;

export const Detail = styled(Box).attrs({
  p: { sm: 4, md: 5 },
})`
  position: relative;
  height: 100%;
  padding: 0px !important;
  padding-bottom: 24px;
  .MuiTypography-body1 {
    font-size: 16px;
    font-weight: 700;
    color: #778ba5;
    label {
      color: #48596b;
    }
    a {
      color: #0072a2;
      text-decoration: none;
    }
  }
  .MuiTypography-h6 {
    font-size: 24px;
    font-weight: 700;
    color: #48596b;
    span {
      color: #778ba5;
      float: right;
    }
    margin-top: 12px;
    margin-bottom: 12px;
  }
  h4 {
    font-size: 32px;
    font-weight: 400;
    color: #48596b;
    margin-bottom: 24px;
  }
  .MuiButton-containedPrimary {
    height: 48px;
    text-transform: none;
    font-size: 16px;
    font-weight: 700;
    color: #ffffff;
  }
  .i-heading {
    background-color: rgb(235, 240, 246);
    padding: 24px;
    padding-top: 0px;
  }
  .i-body {
    padding: 24px;
    padding-top: 8px;
    .grid-root {
      flex-direction: column;
      align-items: flex-start;
    }
    .ag-root {
      margin-top: 10px;
      border: solid 1px #cbd6e2;
      padding: 20px;
      padding-top: 0px;
      border-radius: 6px;
      font-size: 16px;
      .ag-header {
        font-size: 16px;
      }
    }
  }
  span.subtitle {
    color: #595959;
    font-size: 16px;
    font-weight: 700;
  }
  .MuiInputBase-root {
    height: 48px;
  }
  .MuiFormControl-root {
    .MuiFormLabel-root {
      display: none;
    }
  }
`;

export const ExclusiveToggleButtonGroup = styled(ToggleButtonGroup).attrs({
  exclusive: true,
  size: 'small',
  color: 'secondary',
})``;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  label {
    min-width: 150px;
  }
`;

export const Button = styled(MUIButton).attrs({
  variant: 'contained',
})``;

export const Actions = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;

  & *:not(last-child) {
    margin-right: 10px;
  }
`;

export const ButtonSpacer = styled.div`
  width: 16px;
`;

export const SubOption = styled.div`
  padding: 0 32px;
  display: flex;
  & > * {
    flex: 1 1 auto;
  }
  & > *:not(last-child) {
    margin-right: 10px;
  }
  .MuiFormLabel-root.MuiInputLabel-shrink {
    display: none;
  }
`;

export const ProgramRoot = styled.div`
  .MuiButtonBase-root {
    float: right;
    margin-bottom: 15px;
  }
`;

export const InfoText = styled(Typography)`
  color: ${COLORS.greyDark};
  margin-bottom: ${SPACERS.large};
`;

export const Warning = styled(Typography)`
  color: #800000;
`;

export const GroupTitle = styled.div`
  color: #0072a2;
  font-size: 16px;
  font-weight: bold;
  span {
    color: #778ba5;
  }
`;
